var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spark-chart",attrs:{"id":'sparkchart-'+_vm.resource+_vm.mode}})}
var staticRenderFns = []

export { render, staticRenderFns }